import { render, staticRenderFns } from "./MessengerBindAnalysis.vue?vue&type=template&id=b9291a86&scoped=true"
import script from "./MessengerBindAnalysis.vue?vue&type=script&lang=js"
export * from "./MessengerBindAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9291a86",
  null
  
)

export default component.exports